import $ from "jquery";
import _ from "underscore";
import {showElementAt, doOnceOnWindowResize} from "../atBrowserUtils";

/**
 * @author kostenko
 *
 * @constructor
 *
 * @param config configuration object
 *
 * @config dialogDiv HTML div with dialog content (a selector, element, jQuery object or HTML snippet)
 * @config [onOkClick] function to perform after the user clicks 'OK' button, but before the dialog is closed.
 *                     Must return true to close the dialog and false to cancel closing
 *                     Mandatory if hideButtons is false.
 * @config [onClose] function to perform when the dialog is closed (either way)
 * @config [okButtonText] text for the 'OK' button ('OK' by default)
 * @config [cancelButtonText] text for the 'Cancel' button ('Cancel' by default)
 * @config [buttonsPlaceholder] buttons placeholder (a selector, element, or jQuery object)
 *                              (if not specified, a standard button pane will be shown)
 * @config [hideButtons] if true, then button pane won't be displayed (false by default)
 * @config [wrapperClass] additional class for wrapper. (ignore by default)
 * @config [isWithBeak] if true, then dialog will be with beak (false by default)
 * @config [beakOnBottom] if true, then beak will be on bottom (false by default, ignored when isWithBeak==false)
 * @config [notModal] if true, then dialog won't be modal, and there will be no overlay to handle 'outside' clicks to close the dialog (false by default)
 * @config [hideOnResize] if true, then dialog will be hidden on window resize (false by default)
 * @config [showEmptyTitleBar] if true, title bar will be visible even if title is empty
 */
function DropdownDialog( config )
{
    /**
     * Shows the dialog at the specified element (e.g. a button).
     * @param element HTML element to show the dialog at (a selector, element, or jQuery object)
     * @param positionParams params which will be user is positioning (if not specified, default params will be used)
     * @positionParams [my]
     * @positionParams [at]
     * @positionParams [offset]
     * @positionParams [collision]
     */
    this.showAt = function (element, positionParams)
    {
        dialog.dialog('open');

        if( !positionParams ) positionParams = {};
        positionParams.of = $( element );
        showElementAt( wrapper, positionParams );

        var outside = $('.ui-widget-overlay');
        if ( config.outsideClickCallback  )
            outside.click(config.outsideClickCallback);
        else {
            // close the dialog when user clicks outside
            outside.click( function() { dialog.dialog('close'); } );
        }
        
        if (config.hideOnResize)
            this.removeListenersFn = doOnceOnWindowResize( function () {
                dialog.dialog('close');
                if ( config.hideOnResizeCallback )
                    config.hideOnResizeCallback();
            } );
    };

    this.hide = function()
    {
        dialog.dialog('close');
        if (this.removeListenersFn) 
            this.removeListenersFn();
        this.removeListenersFn = null;
    };

    this.getWrapper = function() {
        return dialog.parent()
    }

    this.removeOverlay = function()
    {
        $('.ui-widget-overlay' ).remove();
    };

    /**
     * After calling this method it would be impossible to close the dialog in any way.
     * It also applies 'disabled' class to the close button element, so it can be styled as disabled.
     */
    this.preventClose = function()
    {
        dialog.on("dialogbeforeclose", false);
        wrapper.find(".ui-dialog-titlebar-close").addClass("disabled");
    };

    /**
     * Call this method to allow closing the dialog again.
     */
    this.allowClose = function()
    {
        dialog.off("dialogbeforeclose");
        wrapper.find(".ui-dialog-titlebar-close").removeClass("disabled");
    };

    this.setBeak = function(beakOnBottom) {
        wrapper.toggleClass("ui-dialog-with-top-beak", !beakOnBottom);
        wrapper.toggleClass("ui-dialog-with-bottom-beak", !!beakOnBottom);
    };

    // ---------- private ----------

    // If the provided div is an HTML snippet, we must insert it into DOM.
    // Actually, jQuery UI Dialog can accept HTML snippet, but we cannot determine its width until it is in DOM.
    // And we need its width to initialize jQuery UI Dialog, to allow the user to use CSS to set the width.
    if ($.type(config.dialogDiv) == "string")
        config.dialogDiv = $(config.dialogDiv).appendTo('body');

    var dialog = $(config.dialogDiv).dialog({
        autoOpen: false,
        draggable: false,
        resizable: false,
        modal: !config.notModal, // this is needed for overlay to appear, so we can handle 'outside' clicks to close the dialog
        buttons: [
            {
                text: config.okButtonText || 'OK',
                click: function()
                {
                    if (config.onOkClick())
                        dialog.dialog('close');
                }
            },
            {
                text: config.cancelButtonText || 'Cancel',
                click: function()
                {
                    dialog.dialog('close');
                }
            }
        ],
        close: config.onClose,
        width: $(config.dialogDiv).width(), // this is why we need the dialog div to be in DOM already
        minHeight: 0,
        //TODO: needs zindex refactoring
        zIndex: config.zIndex,
        closeOnEscape: _.isUndefined(config.closeOnEscape) ? true : config.closeOnEscape
    });

    // when the dialog is created, it is wrapped into a container, let's store the reference to it
    var wrapper = dialog.parent();

    if (config.wrapperClass) {
        wrapper.addClass(config.wrapperClass);
    }

    var ua = navigator.userAgent.toLowerCase();
    var isIE8 = ua.indexOf("msie 8") > -1;
    var isIE7 = ua.indexOf("msie 7") > -1;

    if (config.isWithBeak && !isIE8 && !isIE7) {
        wrapper.addClass("ui-dialog-with-beak");
        this.setBeak(!!config.beakOnBottom);
    }

    if (config.hideButtons)
    {
        wrapper.find('.ui-dialog-buttonpane').hide();
    }
    else if (config.buttonsPlaceholder)
    {
        wrapper.find('.ui-dialog-buttonset').appendTo(dialog.find(config.buttonsPlaceholder));
        wrapper.find('.ui-dialog-buttonpane').hide();
    }

    if (!config.showEmptyTitleBar && !dialog.dialog('option', 'title'))
        wrapper.find('.ui-dialog-titlebar').hide();
}

export default DropdownDialog



// WEBPACK FOOTER //
// ./web/js/controls/DropdownDialog.js